module.exports = __webpack_public_path__ + "static/img/fachada_parking2.fb7a3ad7.jpg";